export enum TransferTypeEnum {
  PIX = 'PIX',
  TED = 'TED',
  INTERNAL = 'ENTRE CONTAS LADYBANK',
  TODAS = 'TODAS'
}
